import { connect, ConnectedProps, useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import { RootState } from '../../lib/store';
import { setIsChangeUserPassword } from '../../lib/store/auth';
import { login as serviceLogin, logout as serviceLogout } from '../../lib/store/common-actions';
import { isUserVerifiedStatus } from '../../lib/store/selectors';

import ArrowRight from '../../assets/img/chevron-right.png';
import AppVersion from '../../components/AppVersion/AppVersion';
import { BaseModal, UserPhoto } from '../../components/index';
import config from '../../config';
import { useIsMobile } from '../../hooks';

import ChangePasswordModal from './ChangePassword/ChangePasswordModal';
import { getMenuList } from './helpers';
import { myProfileIds } from './MyProfile.constants';
import { MyProfileItem } from './MyProfile.types';

import styles from './MyProfile.module.scss';

type OwnProps = {};
type Props = OwnProps & ReduxProps;

const MyProfile = ({ logout, login, isUserVerified, individual }: Props) => {
  const dispatch = useDispatch();
  const { isMobile } = useIsMobile();

  const isChangeUserPassword = useSelector<RootState, boolean>((state: RootState) => state.auth.isChangeUserPassword);
  const menu = getMenuList().slice(0, -1);
  const logoutMenuItem = getMenuList().slice(-1)[0];

  const handleLogout = () => {
    logout();
    login();
  };

  const handleOptionClick = (id: string) => {
    if (id === myProfileIds.security) {
      handleModal();
      return;
    }
    if (id === myProfileIds.helpCenter) {
      window.open(config.links.helpCenterUrl, '_blank');
    }
  };

  const handleModal = () => {
    dispatch(setIsChangeUserPassword(!isChangeUserPassword));
  };
  const isDisabledLink = (item: MyProfileItem): boolean => item.id === myProfileIds.documents && !isUserVerified;

  return (
    <div className={styles.wrapper}>
      <div className={styles.userWrapper}>
        <div className={styles.user}>
          <UserPhoto isHeader fullSize first_name={individual?.first_name} last_name={individual?.last_name} />
        </div>
        <div className={styles.userInfo}>
          <div>
            <span className={styles.name}>{`${individual?.first_name} ${individual?.last_name}`}</span>
          </div>
          <span className={styles.email}>{individual?.email}</span>
        </div>
      </div>
      <div className={styles.menuWrapper}>
        {menu.map((item) => (
          <NavLink
            className={isDisabledLink(item) ? styles.linkDisabled : styles.link}
            id={item.id}
            key={item.id}
            to={{
              pathname: item?.path && !isDisabledLink(item) ? item.path : '',
            }}
            onClick={() => handleOptionClick(item.id)}
          >
            <div key={item.id} className={styles.item}>
              <div className={styles.imageAndName}>
                <div className={styles.imgageWrapper}>
                  <img
                    className={isDisabledLink(item)
                      ? styles.imageDisabled
                      : styles.image}
                    src={item.img}
                    alt={item.label}
                  />
                </div>
                <div className={styles.label}>{item.label}</div>
              </div>
              <div className={styles.arrowWrapper}>
                <img className={styles.arrow} src={ArrowRight} alt="arrow" />
              </div>
            </div>
          </NavLink>
        ))}
      </div>
      <div className={styles.menuWrapper}>
        <NavLink
          className={styles.link}
          id={logoutMenuItem.id}
          key={logoutMenuItem.id}
          onClick={() => handleLogout()}
          to={{}}
        >
          <div key={logoutMenuItem.id} className={classNames(styles.item, styles.logoutItem)}>
            <div className={styles.imageAndName}>
              <div className={styles.imgageWrapper}>
                <img className={styles.image} src={logoutMenuItem.img} alt={logoutMenuItem.label} />
              </div>
              <div className={styles.label}>{logoutMenuItem.label}</div>
            </div>
            <div className={styles.arrowWrapper}>
              <img className={styles.arrow} src={ArrowRight} alt="arrow" />
            </div>
          </div>
        </NavLink>
      </div>
      <BaseModal isOpen={isChangeUserPassword}>
        {isChangeUserPassword && <ChangePasswordModal handleModal={handleModal} />}
      </BaseModal>
      <AppVersion />
    </div>
  );
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  dispatch,
  logout: () => dispatch(serviceLogout()),
  login: () => {
    dispatch(serviceLogin('login'));
  },
});

const mapStateToProps = (state: RootState) => ({
  isUserVerified: isUserVerifiedStatus(state.crm.individualExtendedInfo),
  individual: state.crm.individualExtendedInfo,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
